module.exports = __webpack_public_path__ + "static/media/golfer-7-a.9ddf3ca3.png";